/**
 * Horizontal swipe / drag on PDP main image → previous / next gallery image.
 * Usage: suaveBindMainImageSwipe(element, onNext, onPrev, { swipeClass: '...' })
 */
(function () {
  function bindHorizontalSwipe(element, onNext, onPrev, options) {
    options = options || {};
    if (!element || element._suaveHorizontalSwipeBound) return element;
    element._suaveHorizontalSwipeBound = true;

    var minDist = options.minDistance != null ? options.minDistance : 50;
    var maxVertical = options.maxVerticalDrift != null ? options.maxVerticalDrift : 80;
    var tracking = false;
    var startX = 0;
    var startY = 0;
    var activePointerId = null;

    if (options.swipeClass) element.classList.add(options.swipeClass);

    function finishSwipe(clientX, clientY) {
      var dx = clientX - startX;
      var dy = clientY - startY;
      tracking = false;
      activePointerId = null;
      if (Math.abs(dx) < minDist) return;
      if (Math.abs(dy) > maxVertical && Math.abs(dy) > Math.abs(dx)) return;
      if (dx < 0) {
        if (onNext) onNext();
      } else if (onPrev) {
        onPrev();
      }
    }

    element.addEventListener(
      'touchstart',
      function (e) {
        if (!e.touches || e.touches.length !== 1) return;
        tracking = true;
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
      },
      { passive: true }
    );

    element.addEventListener(
      'touchend',
      function (e) {
        if (!tracking) return;
        var touch = e.changedTouches && e.changedTouches[0];
        if (!touch) return;
        finishSwipe(touch.clientX, touch.clientY);
      },
      { passive: true }
    );

    element.addEventListener('touchcancel', function () {
      tracking = false;
      activePointerId = null;
    });

    element.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return;
      if (e.button !== 0) return;
      tracking = true;
      activePointerId = e.pointerId;
      startX = e.clientX;
      startY = e.clientY;
      try {
        element.setPointerCapture(e.pointerId);
      } catch (err) {
        /* ignore */
      }
    });

    element.addEventListener('pointerup', function (e) {
      if (!tracking || e.pointerId !== activePointerId) return;
      finishSwipe(e.clientX, e.clientY);
      try {
        element.releasePointerCapture(e.pointerId);
      } catch (err) {
        /* ignore */
      }
    });

    element.addEventListener('pointercancel', function () {
      tracking = false;
      activePointerId = null;
    });

    return element;
  }

  window.suaveBindMainImageSwipe = bindHorizontalSwipe;
})();
